module.exports = __webpack_public_path__ + "img/join_4_2.3d247ba7.jpg";